// components/ActiveFilterChips.jsx

import React from "react";
import { FaTimes } from "react-icons/fa";

export default function ActiveFilterChips({
  chips = [],
  onRemove,
  onClear,
}) {
  if (chips.length === 0) return null;

  return (
    <div className="flex flex-col gap-2 rounded-2xl border border-slate-200 bg-white px-3 py-3 shadow-sm dark:border-white/10 dark:bg-slate-900">
      <div className="flex items-center justify-between gap-3">
        <p className="text-[11px] font-black uppercase tracking-[0.14em] text-slate-500 dark:text-slate-400">
          Filtres actifs
        </p>

        <button
          type="button"
          onClick={onClear}
          className="text-xs font-bold text-red-600 transition hover:underline dark:text-red-400"
        >
          Tout effacer
        </button>
      </div>

      <div className="flex flex-wrap gap-2">
        {chips.map((chip) => (
          <button
            key={chip.id}
            type="button"
            onClick={() => onRemove?.(chip)}
            title={`Supprimer le filtre ${chip.label}`}
            className={[
              "inline-flex max-w-full items-center gap-2 rounded-full border px-3 py-1.5",
              "border-red-200 bg-red-50 text-xs font-bold text-red-700",
              "transition hover:border-red-300 hover:bg-red-100",
              "dark:border-red-900/70 dark:bg-red-950/30 dark:text-red-300",
              "dark:hover:bg-red-950/50",
            ].join(" ")}
          >
            <span className="max-w-[240px] truncate">
              {chip.label}
            </span>

            <FaTimes className="shrink-0 text-[10px]" />
          </button>
        ))}
      </div>
    </div>
  );
}